import { render, staticRenderFns } from "./ProductBase.vue?vue&type=template&id=5d8c2707&scoped=true&"
import script from "./ProductBase.vue?vue&type=script&lang=js&"
export * from "./ProductBase.vue?vue&type=script&lang=js&"
import style0 from "./ProductBase.vue?vue&type=style&index=0&id=5d8c2707&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8c2707",
  null
  
)

export default component.exports